// Types
import type { DataType } from "../../types"
import type { ErrorType } from "../hooks"

// Utils
import { sweetAlert } from "utils"

export function getFinalMessage(
  data: DataType[],
  error: ErrorType[],
  success: number
): void {
  // Vars
  const status = {
    success: success === data.length,
    error: error.length === data.length
  }

  // Functions
  const getMessage = (): string => {
    if (success >= data.length) {
      return "All data has been imported!"
    } else if (error.length >= data.length) {
      return "All data can't be imported! \n Please check the error details on the import data"
    }

    return "All data can't be imported! \n You can check the error details on the import data and download the error data to be fixed"
  }

  sweetAlert(
    getMessage(),
    { icon: status.success ? "success" : status.error ? "error" : "info" }
  )

  return
}